import React from 'react';
import './styles.scss';

export interface ChatChannel {
  id: string;
  label: string;
  // Whether a normal (non-slash) message typed while this tab shows is sent as HRP (global scope)
  sendsGlobal: boolean;
}

// 'all' shows every line; the three others filter on the channel App.js tags each message with.
export const CHAT_CHANNELS: ChatChannel[] = [
  { id: 'all', label: 'Tout', sendsGlobal: false },
  { id: 'local', label: 'Local', sendsGlobal: false },
  { id: 'hrp', label: 'HRP', sendsGlobal: true },
  { id: 'system', label: 'Système', sendsGlobal: false },
];

export const DEFAULT_CHANNEL = 'all';

export const isKnownChannel = (id: unknown): id is string =>
  typeof id === 'string' && CHAT_CHANNELS.some((c) => c.id === id);

// Tab a message belongs to. Private notices come from the server as sender "Système".
export const channelOfMessage = (sender: string, global: boolean): string => {
  if (sender === 'Système') return 'system';
  return global ? 'hrp' : 'local';
};

const Channels = (props: {
  active: string,
  onSelect: (id: string) => void,
  unread: Record<string, number>,
}) => {
  return (
    <div className="chat-channels">
      {CHAT_CHANNELS.map((channel) => {
        const count = props.active === channel.id ? 0 : (props.unread[channel.id] || 0);
        return (
          <button
            key={channel.id}
            type="button"
            // Keep the chat input focused when a tab is clicked
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => props.onSelect(channel.id)}
            className={`chat-channel channel-${channel.id} ${props.active === channel.id ? 'active' : ''}`}
          >
            {channel.label}
            {count > 0 && <span className="chat-channel-unread">{count > 99 ? '99+' : count}</span>}
          </button>
        );
      })}
    </div>
  );
};

export default Channels;
